import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CollegeInfoService {

  constructor(private http: HttpClient) {
  }

  getColleges(langID: string) {
    return this.http.get(`api/s/colleges/names/${langID}`);
  }

  getCollegesWithGrant(centerProfessionID: number, specializationId: number, educatedId: number, studylanguageId: number, langID: string, paymentformid: number) {
    return this.http.get(`api/s/colleges/names/grant/${centerProfessionID}/${specializationId}/${educatedId}/${studylanguageId}/${langID}/${paymentformid}`);
  }

  getCollegesBy(filter: any) {
    return this.http.post(`api/s/colleges/names/filter`, filter);
  }

  getCollegeInfoByID(universityID: number, langID: string) {
    return this.http.get(`api/s/colleges/get/${universityID}/${langID}`);
  }

  getKnowledgeFields(langID: string) {
    return this.http.get(`api/s/colleges/knowledgeFields/${langID}`);
  }

  getSummaryData(langID: string) {
    return this.http.get(`api/s/colleges/summaryData/${langID}`);
  }

  getNotCivilCollegeList() {
    return this.http.get<any[]>('api/dic/college/non/civil/list');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/college-info.service.ts